<template>
  <div id="app" :style="restyle">
    <component :is="layout">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </component>
  </div>
</template>

<script>
export default {
  data() {
    return {
      vw: 0,
      vh: 0,
      appKey: 0
    }
  },
  computed: {
    layout() {
      return this.$route.meta.layout
    }
  },
  methods: {
    restyle() {
      return {
        width: `${this.vw}px`,
        height: `${this.vh}px`
      }
    },
    resize() {
      this.vw = Math.max(
        document.documentElement.clientWidth || 0,
        window.innerWidth || 0
      )
      this.vh = Math.max(
        document.documentElement.clientHeight || 0,
        window.innerHeight || 0
      )
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.resize)
  },
  created() {
    window.addEventListener('resize', this.resize)
  }
}
</script>

<style>
@import url('./styles/common.css');
@import url('./styles/color.css');

@font-face {
  font-family: 'Montserrat';
  src: url('./assets/fonts/Montserrat/Montserrat-Regular.ttf')
    format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Montserrat-Bold';
  src: url('./assets/fonts/Montserrat/Montserrat-Bold.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

html,
body,
#app {
  height: 100%;
  margin: 0;
  padding: 0;
}

#app {
  margin: 0;
  padding: 0;
  font-family: 'Montserrat';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

button {
  cursor: pointer;
}
* {
  -webkit-box-sizing: content-box !important;
  -moz-box-sizing: content-box !important;
  box-sizing: content-box !important;
}
*:before,
*:after {
  -webkit-box-sizing: content-box !important;
  -moz-box-sizing: content-box !important;
  box-sizing: content-box !important;
}
/* 
*::-webkit-scrollbar{
  display: none;
} */
.mx-input {
  border: 1px solid #dfdfdf !important;
  padding: 6px 0 6px 10px !important;
  font-size: 13px;
}

.error .mx-input {
  border-color: red !important;
}

.mx-date-row {
  height: 32px;
}
.mx-calendar-content {
  height: unset !important;
}
.mx-calendar-content .cell {
  border: solid 1px white;
}
select {
  background-color: #ffffff !important;
  background-position-y: 8px !important;
  width: 100%;
  height: 40px;
  border: 1px solid #cbd4dc;
  box-sizing: border-box;
  border-radius: 5px;
  -webkit-appearance: none;
  -moz-appearance: none;
  background: transparent;
  background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
  background-repeat: no-repeat;
  background-position-x: 100%;
  background-position-y: 5px;
  border: 1px solid #dfdfdf;
  border-radius: 2px;
  color: #2c3e50;
  padding-left: 16px;
  font-size: 13px;
  font-family: 'Montserrat';
  cursor: pointer;
}
</style>
